<template>
  <v-tooltip top>
    <v-btn fab dark small color="amber darken-2" slot="activator" @click="assign()">
      <v-icon>assignment</v-icon>
    </v-btn>
    <span>{{title}}</span>
  </v-tooltip>
</template>

<script>
export default {
  props: {
    title: String
  },
  methods: {
    assign() {
      this.$emit("assign");
    }
  }
};
</script>

<style>
</style>
